"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Avatar = void 0;
var tslib_1 = require("tslib");
var ui_helper_deep_branding_1 = require("@hopin-team/ui-helper-deep-branding");
var ui_helper_with_space_1 = require("@hopin-team/ui-helper-with-space");
var ui_visually_hidden_1 = require("@hopin-team/ui-visually-hidden");
var react_1 = tslib_1.__importStar(require("react"));
var fallback_1 = require("./partials/fallback");
var image_1 = require("./styled/image");
var root_1 = require("./styled/root");
var signal_1 = require("./styled/signal");
var Avatar = function (_a) {
    var __UIScope = _a.__UIScope, testID = _a["data-testid"], alt = _a.alt, className = _a.className, firstName = _a.firstName, isOnline = _a.isOnline, _b = _a.isOnlineText, isOnlineText = _b === void 0 ? 'Online' : _b, lastName = _a.lastName, scale = _a.scale, size = _a.size, src = _a.src, withBorder = _a.withBorder, href = _a.href;
    var _c = tslib_1.__read((0, react_1.useState)(false), 2), errored = _c[0], setErrored = _c[1];
    var rootClasses = (0, ui_helper_deep_branding_1.useEscapeClasses)({
        block: 'Avatar',
        className: className,
        __UIScope: __UIScope,
    }).rootClasses;
    var polymorphicProps = href
        ? {
            as: 'a',
            href: href,
        }
        : {};
    return (react_1.default.createElement(root_1.Root, tslib_1.__assign({ className: rootClasses, "data-testid": testID, scale: scale, size: size, withBorder: withBorder }, polymorphicProps), (errored || !src) && (firstName || lastName) ? (react_1.default.createElement(fallback_1.Fallback, { firstName: firstName, isOnline: isOnline, isOnlineText: isOnlineText, lastName: lastName, scale: scale, size: size, alt: alt })) : (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(image_1.Image, { src: src, alt: alt, onError: function () { return void setErrored(true); } }),
        isOnline && react_1.default.createElement(ui_visually_hidden_1.VisuallyHidden, null, isOnlineText),
        isOnline && react_1.default.createElement(signal_1.Signal, { pattern: "success", sizeOption: size })))));
};
var AvatarWithSpace = (0, ui_helper_with_space_1.withSpace)(Avatar);
exports.Avatar = AvatarWithSpace;
//# sourceMappingURL=avatar.js.map